import axios from 'axios';
import { REACT_APP_API_URL } from '../assets/conf/api-endpoints';
import {
	getLocalStorage,
	removeLocalStorageItem,
	toastError,
	clearPatientFilters,
	clearRadiologistFilters,
	getNonce,
	getHeaderTimestamp,
	generateHeaderToken,
} from '../utils/globals.utils';
import { AUTH_HOME } from '../utils/constants';

const ctdentInstance = axios.create({
	baseURL: REACT_APP_API_URL,
});

ctdentInstance.interceptors.request.use(
	(config) => {
		const accessToken = getLocalStorage('authToken') || '';
		const tempAccessToken = getLocalStorage('tempAuthToken') || '';
		if (accessToken) {
			config.headers['accesstoken'] = accessToken;
		} else if (tempAccessToken) {
			config.headers['accesstoken'] = tempAccessToken;
		}
		const nonce = getNonce();
		const timestamp = getHeaderTimestamp();
		const token = generateHeaderToken(timestamp);

		config.headers['nonce'] = nonce;
		config.headers['timestamp'] = timestamp;
		config.headers['token'] = token;
		return config;
	},
	(error) => {
		return Promise.reject(error);
	},
);

ctdentInstance.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		const accessToken = getLocalStorage('authToken') || '';
		const tempAccessToken = getLocalStorage('tempAuthToken') || '';
		if (
			error?.response?.data?.responseCode === 401 &&
			(accessToken || tempAccessToken)
		) {
			removeLocalStorageItem('userId');
			removeLocalStorageItem('authToken');
			clearPatientFilters();
			clearRadiologistFilters();
			window.location.href = AUTH_HOME;
			toastError('Session expired. Please login again.');
		}
		return Promise.reject(error);
	},
);

export default ctdentInstance;
